import { render, staticRenderFns } from "./DetalhesDadosGeraisDispensaInexigibilidade.vue?vue&type=template&id=6da93975"
import script from "./DetalhesDadosGeraisDispensaInexigibilidade.vue?vue&type=script&lang=ts"
export * from "./DetalhesDadosGeraisDispensaInexigibilidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports